import React from 'react'
import AboutMeContainer from '../components/AboutMeContainer'


const About = () => {
  return (
    <>
    <AboutMeContainer/>
    </>
  )
}

export default About